 <template lang="pug">
    .landingpage
        .section.header(v-if="headerSections.length" v-for="(section, index) in headerSections" :key="section.id" :class="section.key")
            Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
        .container(ref="container" )
            .socialmedia-wrapper
                SocialMediaButtons(:style="{ right: computedMargin }")
            .section.body(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
                Heading(
                    v-if="section.key === 'heading'" :section="section"
                    heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile"
                    sub-heading-class="is-size-6 is-uppercase has-text-primary"
                )
                Slider(v-if="section.key === 'slider'" :section="section")
                CategoryPosts(
                    v-if="section.key === 'categoryposts'"
                    :section="section"
                    :per-page="4"
                    orientation="horizontal"
                )
                ImageSection(v-if="section.key === 'image'" :section="section")
                Post(v-if="section.key === 'post'" :section="section")
                Sites(v-if="section.key === 'sites'" :section="section")
                Accordion(v-if="section.key === 'accordion'" :section="section")
</template>

<script>

import { debounce } from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import Slider from '@/components/Slider'
import ImageSection from '@/components/ImageSection'
import CategoryPosts from '@/components/CategoryPosts'
import Post from '@/components/Post'
import Banner from '@/components/Banner'
import Sites from '@/components/Sites'
import Accordion from '@/components/Accordion'
import SocialMediaButtons from '@/components/SocialMediaButtons'


export default {
    name: 'LandingPage',
    components: {
        Heading,
        Slider,
        ImageSection,
        CategoryPosts,
        Post,
        Banner,
        Sites,
        Accordion,
        SocialMediaButtons
    },
    data() {
        return {
            margin: 0
        }
    },
    computed: {
        headerSections() {
            return this.filteredSections.filter(section => section.area === 'header')
        },
        mainSections() {
            return this.filteredSections.filter(section => section.area === 'main')
        },
        computedMargin() {
            return '-' + this.margin + 'px'
        },
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'slider'
                    || section.key === 'categoryposts'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'banner'
                    || section.key === 'sites'
                    || section.key === 'accordion'
            })
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    },
    methods: {
        getRightMargin() {
            const style = getComputedStyle(this.$refs.container)
            this.margin = parseFloat(style.marginRight)
        }
    },
    mounted() {
        const getRightMarginResize = () => {
            this.getRightMargin()
        }
        window.addEventListener('resize', debounce(getRightMarginResize, 100))
        getRightMarginResize()
    }
}

</script>

<style lang="sass" scoped>
    @import "~bulma/sass/utilities/mixins"
    .socialmedia-wrapper
        +mobile
            display: none
        +touch
            display: none
    .section
        padding: 1.5rem !important
    .section.sites
        padding: 1.5rem 0 !important
    .section.slider,
    .section.banner
        padding: 0
    .section.header
        padding: 0 0 3rem 0 !important
    .section.accordion
        padding: 0rem 0 !important
</style>
